import React, { useState, useCallback } from "react";
import styles from './header.module.css';
import { Link } from "react-router-dom";
import { FadeIn } from "../../shared/ui/animations";
import { CgProfile } from "react-icons/cg";
import { HashLink } from "react-router-hash-link";
import { useUser } from "../../entities/user/model/UserContext.jsx";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { user } = useUser();

    const toggleMenu = useCallback(() => {
        setMenuOpen(prev => !prev);
    }, []);

    const isLoggedIn = Boolean(user);
    const fio = user?.name + " " + user?.surname;

    return (
        <FadeIn delay={200}>
            <header className={styles.stickyHeader}>
                <div className={`${styles.header} container-custom`}>
                    <HashLink to="/#main-page" className={styles.logo}>
                        <img className="img-fluid" src="/images/logo-green.svg" alt="logo" />
                    </HashLink>

                    {/* Бургер для мобильной версии */}
                    <div
                        className={`${styles.burger} ${menuOpen ? styles.open : ''}`}
                        onClick={toggleMenu}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    {/* Навигация */}
                    <nav className={`navbar nav ${styles.nav} ${menuOpen ? styles.showMenu : ''}`}>
                        <div className={styles.navItems}>
                            <div className={styles.navItemsWrapper}>
                                {/*<HashLink className={styles.navItem} to={"/#aboutSection"} onClick={toggleMenu}>О нас</HashLink>*/}
                                {/*<HashLink className={styles.navItem} to={"/#games"} onClick={toggleMenu}>Игры</HashLink>*/}
                                <HashLink className={styles.navItem} to={"/#scheduleSection"} onClick={toggleMenu}>Расписание</HashLink>
                                <Link to={`/catalog`} className={styles.navItem} onClick={toggleMenu}>
                                    Каталог игр
                                </Link>
                                <Link to={`/masters`} className={styles.navItem} onClick={toggleMenu}>
                                    О мастерах
                                </Link>
                            </div>

                            {/* Кнопка Войти/Профиль (мобилка) */}
                            {isLoggedIn ? (
                                <Link
                                    to="/profile"
                                    onClick={toggleMenu}
                                    className={`${styles.btnMobile} ${styles.profile} btn-word body capital logoutButton`}
                                >
                                    <CgProfile />
                                    {fio}
                                </Link>
                            ) : (
                                <Link
                                    to="/auth"
                                    onClick={toggleMenu}
                                    className={`${styles.btnMobile} btn btn-red-outline`}
                                >
                                    Войти
                                </Link>
                            )}
                        </div>
                    </nav>

                    {/* Кнопка Войти/Профиль (десктоп) */}
                    {isLoggedIn ? (
                        <Link to="/profile" className={`${styles.btnDesc} ${styles.profile} btn-word body capital logoutButton`}>
                            <CgProfile />
                            {fio}
                        </Link>
                    ) : (
                        <Link to="/auth" className={`${styles.btnDesc} btn btn-red-outline`}>
                            Войти
                        </Link>
                    )}
                </div>
            </header>
        </FadeIn>
    );
};

export default Header;
